module.exports = "https://static.wmbcdn.com/uniweb/images/a04b551748ba8354fa58d94e42a79491.svg";